const translations = {
  en: {
    depositTitle: 'Deposit with Credit or Debit Card',
    fullName: 'Full name on card',
    currency: 'Currency',
    amount: 'Amount',
    depositLimits: 'Deposit Limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    creditCardNumber: 'Credit Card Number',
    billingInfo: 'Billing Information',
    sameAddress: 'Tick this check box If your residential address is the same as billing address.',
    address: 'Address',
    city: 'City',
    zipCode: 'Zip Code',
    back: 'BACK',
    deposit: 'DEPOSIT',
    amountRequired: 'Amount required',
    invalidCard: 'Invalid Creditcard number',
    invalidBrand: 'You need to enter a credit card number from a brand that is supported.',
    invalidCvv: 'You need to enter a valid cvv number.',
    invalidExpDate: 'Credit Card Expiration Date should be at least on this month.<br/> Date format is <b>MM/YY</b>',
    invalidExp: 'Invalid expiration date',
    depositStatus: 'Credit Card Deposit Status',
    errorDeposit: 'Error with Creditcard deposit',
    error: 'Error',
    warning: 'Warning',
  },
  es: {
    depositTitle: 'Depósito con Tarjeta de Crédito o Débito',
    fullName: 'Nombre completo en la tarjeta',
    currency: 'Moneda',
    amount: 'Monto',
    depositLimits: 'Límites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    creditCardNumber: 'Número de Tarjeta de Crédito',
    billingInfo: 'Información de Facturación',
    sameAddress: 'Marque esta casilla si su dirección residencial es la misma que la de facturación.',
    address: 'Dirección',
    city: 'Ciudad',
    zipCode: 'Código Postal',
    back: 'ATRÁS',
    deposit: 'DEPOSITAR',
    amountRequired: 'Monto requerido',
    invalidCard: 'Número de tarjeta de crédito inválido',
    invalidBrand: 'Debe ingresar un número de tarjeta de una marca soportada.',
    invalidCvv: 'Debe ingresar un número CVV válido.',
    invalidExpDate: 'La fecha de expiración debe ser al menos del mes actual.<br/> El formato es <b>MM/AA</b>',
    invalidExp: 'Fecha de expiración inválida',
    depositStatus: 'Estado del Depósito con Tarjeta',
    errorDeposit: 'Error en el depósito con tarjeta',
    error: 'Error',
    warning: 'Advertencia',
  },
  pt: {
    depositTitle: 'Depósito com Cartão de Crédito ou Débito',
    fullName: 'Nome completo no cartão',
    currency: 'Moeda',
    amount: 'Valor',
    depositLimits: 'Limites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    creditCardNumber: 'Número do Cartão de Crédito',
    billingInfo: 'Informações de Cobrança',
    sameAddress: 'Marque esta caixa se seu endereço residencial é o mesmo que o endereço de cobrança.',
    address: 'Endereço',
    city: 'Cidade',
    zipCode: 'CEP',
    back: 'VOLTAR',
    deposit: 'DEPOSITAR',
    amountRequired: 'Valor obrigatório',
    invalidCard: 'Número de cartão de crédito inválido',
    invalidBrand: 'Você precisa inserir um número de cartão de uma marca suportada.',
    invalidCvv: 'Você precisa inserir um número CVV válido.',
    invalidExpDate: 'A data de expiração do cartão deve ser pelo menos deste mês.<br/> O formato é <b>MM/AA</b>',
    invalidExp: 'Data de expiração inválida',
    depositStatus: 'Status do Depósito com Cartão',
    errorDeposit: 'Erro no depósito com cartão',
    error: 'Erro',
    warning: 'Aviso',
  },
}

export default translations
